import React, { useCallback, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useInvoiceStore } from "../../Store/Invoice";
import LoadingPage from "../LoadingPage";
import ZomentumLogo from "../../Assets/PaymentsAppHeader/ZomentumLogo.svg";
import { toLocalDateString } from "../../Utils/DateUtils";
import { getPaymentMethodDetails } from "../../Contracts/Transaction";
import { useTeamStore } from "../../Store/Team";

const InvoiceReceiptPage: React.FC = () => {
  const { transaction_id, customer_id } = useParams();
  const { receipt, getReceiptDetails } = useInvoiceStore();
  const printRef = useRef<HTMLDivElement>(null);
  const { formatCurrency } = useTeamStore();
  const refreshThings = useCallback(async () => {
    if (customer_id && transaction_id) {
      await getReceiptDetails(customer_id, transaction_id);
    } else {
      console.error("Error fetching receipt details");
      window.alert("Error fetching receipt details");
    }
  }, [customer_id, transaction_id, getReceiptDetails]);

  const handlePrint = () => {
    if (printRef.current) {
      document.body.innerHTML = printRef.current.innerHTML;
      window.print();
      setTimeout(() => {
        window.location.reload();
      }, 10);
    }
  };

  useEffect(() => {
    refreshThings();
  }, [refreshThings]);

  return receipt ? (
    <div className="flex flex-col h-screen bg-gray-100">
      <div ref={printRef} className="flex flex-col">
        <div className="flex items-center m-4 space-x-2">
          {receipt?.partner_display_details?.branding_company_logo_s3_url &&
            receipt?.partner_display_details.branding_company_logo_s3_url.length > 0 && (
              <img
                src={receipt?.partner_display_details.branding_company_logo_s3_url}
                alt="Company Logo"
                className="max-h-10"
              />
            )}
          <span className="font-semibold">{receipt?.partner_display_details.name}</span>
        </div>
        <div className="flex flex-col bg-white py-6 w-[52rem] self-center">
          <div className="text-2xl font-semibold my-2 self-center">Payment Receipt</div>
          <div className="p-6 flex flex-col space-y-4">
            <div className="flex">
              <label className="font-semibold mr-2">Transaction ID:</label>
              <div>{receipt.reference}</div>
            </div>
            <div className="flex">
              <label className="font-semibold mr-2">Date:</label>
              <div>{toLocalDateString(receipt.date)}</div>
            </div>
            <div className="flex">
              <label className="font-semibold mr-2">Payment Method:</label>
              <div>{getPaymentMethodDetails(receipt.payment_method).name}</div>
            </div>
            <div className="flex">
              <label className="font-semibold mr-2">Invoice Amount:</label>
              <div>
                {formatCurrency(receipt.original_amount.value, receipt.original_amount.currency)}
              </div>
            </div>
            {receipt.surcharges_fee_amount.value > 0 && (
              <div className="flex">
                <label className="font-semibold mr-2">{receipt.surcharge_description}:</label>
                <div>
                  {formatCurrency(
                    receipt.surcharges_fee_amount.value,
                    receipt.surcharges_fee_amount.currency
                  )}
                </div>
              </div>
            )}
            <div className="flex">
              <label className="font-semibold mr-2">Amount Paid:</label>
              <div>{formatCurrency(receipt.amount.value, receipt.amount.currency)}</div>
            </div>
          </div>
        </div>
      </div>
      <button
        className="mt-3 border rounded px-4 py-2 border-blue-600 hover:bg-blue-100 text-blue-600 hover:scale-105 w-fit self-center"
        onClick={handlePrint}
      >
        Print Receipt
      </button>
      <div className="flex items-center justify-center space-x-2 m-4 opacity-60">
        <span className="text-xs mt-0.5">Powered by </span>
        <img src={ZomentumLogo} alt="Zomentum Logo" className="w-20" />
      </div>
    </div>
  ) : (
    <div className="w-full h-screen flex items-center justify-center">
      <LoadingPage />
    </div>
  );
};

export default InvoiceReceiptPage;
